import { createSelector } from 'reselect';

const selectRaw = (state) => state.planificadorTarea.view;

const selectRecord = createSelector(
  [selectRaw],
  (raw) => raw.record,
);

const selectLoading = createSelector([selectRaw], (raw) =>
  Boolean(raw.loading),
);

const planificadorTareaViewSelectors = {
  selectLoading,
  selectRecord,
  selectRaw,
};

export default planificadorTareaViewSelectors;
